export enum WebsiteRedirectLinks {
  ContentGuidelines = 'https://www.invisibly.com/content-guidelines',
  PrivacyPolicy = 'https://www.invisibly.com/privacy-policy',
  TermsOfService = 'https://www.invisibly.com/business-terms/',
  Waitlist = 'https://www.invisibly.com/waitlist'
}
